<template>
    <div class="container">
        <div class="rotate">
              
              <!-- 转盘图片 -->
              <div
                class="dish"
                src=""
                :style="{transform:rotate_deg,transition:rotate_transition}"
				>
					
					<div :class="['prize-item', 'prize-item' + index]" :style="'background-image:url('+(item && item.img)+')'" v-for="(item,index) in giftList" :key="index">
						
					</div>
				</div>
              <!-- 指针图片 -->
              <img class="pointer" src="../../assets/image/c_01.png" @click="start" />
            </div>
			<div class="prize-num" >剩余{{ canRunCount }}次抽奖机会</div>
    </div>
</template>

<script>
	var light_timer; //灯光定时器
import api from '@/assets/js/api'

export default {
    name: 'Choujiang11',
    props: {
        canRunCount: {
            type: [Number, String],
            default: 0
        },
        giftList: {
            type: [Array],
            default: () => {
                return []
            }
        }
    },
    data () {
        return {
				allowChoujiang: true,
			  rotate_deg: 0, //指针旋转的角度
			  rotate_transition: "transform 3s ease-in-out" //初始化选中的过度属性控制
        }
    },
    mounted () {
        let self = this;
    },
    methods: {
			/**
			 * 开始抽奖
			 * @param { }
			 */
			async start () {
			    let self = this;
			    if (self.canRunCount == 0) {
			        self.$emit('handleResult', 0);
			        return false;
			    }
			    if (!self.allowChoujiang) {
			        return false;
			    }
			    self.allowChoujiang = false;
			
			    let res = await api('post', '/run').catch(err => {
			        // self.allowChoujiang = true;
			        // console.log(err)
			    })
			
			    let { data, code, msg } = res && res.data;
			    console.log(data, code, msg)
			    
			
			    if (code == 200) {
					let runToInd = 0;
					for (var i = 0; i < self.giftList.length; i++) {
						let item = self.giftList[i];
						if(data.giftId == item.giftId){
							runToInd = i;
						}
					}
					this.rotating(runToInd);
					setTimeout(() => {
						self.allowChoujiang = true;
					    self.$emit('handleResult', data);
					}, 4000);
					let canRunCount = self.canRunCount - 1 >= 0 ? self.canRunCount - 1 : 0;
					
					self.$emit('handlecanRunCount', canRunCount);
			        
			        
			    } else if (code == 181) {
					self.allowChoujiang = true;
			        self.$message.warning("活动还未开始")
			    }
			    else if (code == 182) {
					self.allowChoujiang = true;
			        self.$message.warning("活动已经结束")
			    } else {
					self.allowChoujiang = true;
			        self.$message.warning(msg || "数据异常")
			    }
			},
         
            rotating(winningIndex) {
        
              this.rotate_transition = "transform 3s ease-in-out";
              var rand_circle = 5; //默认多旋转5圈
              //   var winningIndex = Math.floor(Math.random() * 8); //获奖的下标   0-7   没有概率每个平均
              
         
              var randomDeg = 360 - winningIndex * 60; //当前下标对应的角度    45是总共8个扇形区域，每个区域约45度
         
              var deg = rand_circle * 360 + randomDeg; //将要旋转的度数  由于是顺时针的转动方向需要用360度来减
              this.rotate_deg = "rotate(" + deg + "deg)";
         
              var that = this;
              setTimeout(function() {
                that.rotate_deg = "rotate(" + 0 + "deg)"; //定时器关闭的时候重置角度
                that.rotate_transition = "";
              }, 4500);
            },
         
            
    },
}
</script>

<style scoped lang="less">
@page-width: 750;

.container {
    width: unit(579 / @page-width * 100, vw);
    height: unit(579 / @page-width * 100, vw);
    position: absolute;
    top: unit(556 / @page-width * 100, vw);
    left: unit(86 / @page-width * 100, vw);
    // background-color: aliceblue;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}
.times {
  text-align: center;
  line-height: 0.8rem;
  background: #fff;
}
.rotate {
  width: unit(579 / @page-width * 100, vw);
  height: unit(579 / @page-width * 100, vw);
  // background: #ffbe04;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 48%;
  left: 50%;
  transform: translate(-50%, -50%);
}
 
.rotate .dish {
  width: unit(579 / @page-width * 100, vw);
  height: unit(579 / @page-width * 100, vw);
  background-image: url(../../assets/image/cj_03.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
 
.pointer {
  width: unit(150 / @page-width * 100, vw);
  height: unit(150 / @page-width * 100, vw);
  position: absolute;
  top: 48%;
  left: 50%;
  transform: translate(-50%, -50%);
}
 .prize-num {
	 position: absolute;
	 width: 100%;
	 text-align: center;
	 color: #fff;
	 left: unit(0 / @page-width * 100, vw);
	 top: unit(595 / @page-width * 100, vw);
	 font-size: unit(26 / @page-width * 100, vw);
 }
 .prize-item {
	 width: unit(193 / @page-width * 100, vw);
	 height: unit(193 / @page-width * 100, vw);
	 position: absolute;
	 background-size: 100% 100%;
	 left: 0;
	 top: 0;
	 z-index: 2;
	 &.prize-item0 {
	 		 left: unit(193 / @page-width * 100, vw);
	 		 top: unit(36 / @page-width * 100, vw);
	 }
	 &.prize-item1 {
	 		 left: unit(330 / @page-width * 100, vw);
	 		 top: unit(110 / @page-width * 100, vw);
	 			 transform: rotate(60deg);
	 }
	 &.prize-item2 {
	 		 left: unit(330 / @page-width * 100, vw);
	 		 top: unit(270 / @page-width * 100, vw);
	 			 transform: rotate(120deg);
	 }
	 &.prize-item3 {
	 		 left: unit(193 / @page-width * 100, vw);
	 		 top: unit(350 / @page-width * 100, vw);
	 			 transform: rotate(180deg);
	 }
	 &.prize-item4 {
	 		 left: unit(60 / @page-width * 100, vw);
	 		 top: unit(275 / @page-width * 100, vw);
	 			 transform: rotate(240deg);
	 }
	 &.prize-item5 {
	 		 left: unit(60 / @page-width * 100, vw);
	 		 top: unit(120 / @page-width * 100, vw);
	 			 transform: rotate(300deg);
	 }
 }
/* 圆点 */
.rotate .circle {
  position: absolute;
  display: block;
  border-radius: 50%;
  height: 0.16rem;
  width: 0.16rem;
  background: black;
}
 
</style>